interface PaperProps {
  children: React.ReactNode;
  radius?: number;
  className?: string;
  bg?: string;
  onClick?: () => void;
}

export default function Paper({
  children,
  radius = 12,
  className = '',
  bg = 'var(--color-frame-inner)',
  onClick,
}: PaperProps) {
  return (
    <div
      onClick={onClick}
      style={{ borderRadius: radius, background: bg }}
      className={`px-4 py-4 lg:py-6 lg:px-8 w-full relative ${className}`}
    >
      {children}
    </div>
  );
}
